import { RevealLines } from "@/components/RevealText";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { EnquiryForm } from "@/components/EnquiryForm";
import { CONTACT, openWhatsApp } from "@/data/site";
import { Phone, Mail, MessageCircle, MapPin, Clock } from "lucide-react";

const Contact = () => (
  <div data-testid="contact-page">
    <section className="pt-40 pb-16 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <Breadcrumbs items={[{ label: "Contact", to: "/contact" }]} />
        <div className="mt-10 flex items-center gap-4">
          <div className="h-px w-12 bg-edge" />
          <span className="text-[10px] tracking-[0.35em] text-edge uppercase font-bold">
            Contact
          </span>
        </div>
        <RevealLines
          as="h1"
          lines={[
            "Ready when you",
            <>
              are. <span className="text-edge">Really.</span>
            </>,
          ]}
          className="mt-8 font-display font-black uppercase tracking-tighter text-[12vw] md:text-[9vw] lg:text-[6.5vw] leading-[0.9]"
        />
      </div>
    </section>

    <section className="py-20 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 space-y-8">
          <div>
            <div className="text-[10px] tracking-[0.3em] text-edge uppercase mb-3">
              Ways to reach us
            </div>
            <h2 className="font-display uppercase text-3xl md:text-4xl font-black tracking-tighter">
              Three channels, one team.
            </h2>
          </div>

          <a
            href={`tel:${CONTACT.phone}`}
            className="group block border-t border-white/10 pt-6"
            data-testid="contact-phone"
          >
            <div className="flex items-center gap-3 text-slateink text-[10px] tracking-widest uppercase">
              <Phone className="w-4 h-4 text-edge" /> Phone
            </div>
            <div className="font-display uppercase text-2xl md:text-3xl font-bold mt-2 group-hover:text-edge transition-colors">
              {CONTACT.phoneDisplay}
            </div>
          </a>

          <button
            onClick={() => openWhatsApp()}
            className="group block text-left border-t border-white/10 pt-6 w-full"
            data-testid="contact-whatsapp"
          >
            <div className="flex items-center gap-3 text-slateink text-[10px] tracking-widest uppercase">
              <MessageCircle className="w-4 h-4 text-edge" /> WhatsApp
            </div>
            <div className="font-display uppercase text-2xl md:text-3xl font-bold mt-2 group-hover:text-edge transition-colors">
              Chat instantly →
            </div>
          </button>

          <a
            href={`mailto:${CONTACT.email}`}
            className="group block border-t border-white/10 pt-6"
            data-testid="contact-email"
          >
            <div className="flex items-center gap-3 text-slateink text-[10px] tracking-widest uppercase">
              <Mail className="w-4 h-4 text-edge" /> Email
            </div>
            <div className="font-display uppercase text-lg md:text-xl font-bold mt-2 break-all group-hover:text-edge transition-colors">
              {CONTACT.email}
            </div>
          </a>

          <div className="border-t border-white/10 pt-6">
            <div className="flex items-center gap-3 text-slateink text-[10px] tracking-widest uppercase">
              <MapPin className="w-4 h-4 text-edge" /> Coverage
            </div>
            <div className="font-display uppercase text-lg md:text-xl font-bold mt-2">
              Bihar · Pan-India projects on request
            </div>
          </div>

          <div className="border-t border-white/10 pt-6">
            <div className="flex items-center gap-3 text-slateink text-[10px] tracking-widest uppercase">
              <Clock className="w-4 h-4 text-edge" /> Hours
            </div>
            <div className="font-display uppercase text-lg md:text-xl font-bold mt-2">
              Mon – Sat · 9AM to 7PM IST
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 border border-white/10 bg-ink-900/50 p-8 lg:p-10">
          <div className="text-[10px] tracking-[0.3em] text-edge uppercase mb-3">
            Send Enquiry
          </div>
          <h3 className="font-display uppercase text-3xl md:text-4xl font-black tracking-tighter mb-8">
            Tell us about your building.
          </h3>
          <EnquiryForm variant="full" source="contact-page" />
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
